import { SystemEvent, SystemEventLevel } from 'bernie-logger';

export const SOURCE_EVENTS = {
  BEX_API_SOURCE_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'BEX_API_SOURCE_ERROR')
};
